import React from 'react';

interface PageShellProps {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
}

/**
 * Shared shell for dashboard-style pages so we can keep the marketing homepage full width.
 */
export const PageShell: React.FC<PageShellProps> = ({ children, tone = 'light' }) => {
  const toneClasses =
    tone === 'light'
      ? 'bg-slate-50 text-slate-900'
      : 'bg-slate-950 text-slate-100';

  return (
    <div className={`min-h-screen ${toneClasses}`}>
      <div className="mx-auto w-full max-w-7xl px-6 pb-16 pt-12 lg:px-10 xl:px-12">
        {children}
      </div>
    </div>
  );
};

export default PageShell;
